export default __webpack_public_path__ + "static/media/Battery.3b4a6c6e.svg";